import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteProvider } from "@/context/SiteContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import DetailingMenu from "@/pages/DetailingMenu";
import Packages from "@/pages/Packages";
import Estimate from "@/pages/Estimate";
import RequestTime from "@/pages/RequestTime";
import TrustCenter from "@/pages/TrustCenter";
import AscendiaStandard from "@/pages/AscendiaStandard";
import WhatWeUse from "@/pages/WhatWeUse";
import Gallery from "@/pages/Gallery";
import AskAscendia from "@/pages/AskAscendia";
import ForProfessionals from "@/pages/ForProfessionals";
import About from "@/pages/About";
import Reviews from "@/pages/Reviews";
import ServiceAreas from "@/pages/ServiceAreas";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Legal from "@/pages/Legal";
import ClientPortal from "@/pages/ClientPortal";
import PartnerAuth from "@/pages/PartnerAuth";
import PartnerDashboard from "@/pages/PartnerDashboard";
import PublicQuote from "@/pages/PublicQuote";
import PropertyIntelligence from "@/pages/PropertyIntelligence";
import AccountLayout from "@/account/AccountLayout";
import AccountAuth from "@/account/AccountAuth";
import AccountAuthCallback from "@/account/AccountAuthCallback";
import AccountReset from "@/account/AccountReset";
import AccountDashboard from "@/account/AccountDashboard";
import AccountProperties from "@/account/AccountProperties";
import PropertyPassport from "@/account/PropertyPassport";
import AccountQuotes from "@/account/AccountQuotes";
import AccountBookings from "@/account/AccountBookings";
import AccountNotifications from "@/account/AccountNotifications";
import AccountProfile from "@/account/AccountProfile";
import AccountRewards from "@/account/AccountRewards";
import AccountInvoices from "@/account/AccountInvoices";
import InvoicePublic from "@/pages/InvoicePublic";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/admin/AdminLogin";
import AdminDashboard from "@/admin/AdminDashboard";

function App() {
  return (
    <div className="App">
      <SiteProvider>
        <ErrorBoundary>
          <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/detailing-menu" element={<DetailingMenu />} />
              <Route path="/packages" element={<Packages />} />
              <Route path="/estimate" element={<Estimate />} />
              <Route path="/request-time" element={<RequestTime />} />
              <Route path="/ascendia-standard" element={<AscendiaStandard />} />
              <Route path="/what-we-use" element={<WhatWeUse />} />
              <Route path="/trust" element={<TrustCenter />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/ask" element={<AskAscendia />} />
              <Route path="/for-professionals" element={<ForProfessionals />} />
              <Route path="/about" element={<About />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/service-areas" element={<ServiceAreas />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/privacy" element={<Legal type="privacy" />} />
              <Route path="/terms" element={<Legal type="terms" />} />
              <Route path="/portal" element={<ClientPortal />} />
              <Route path="/portal/:token" element={<ClientPortal />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/partners/login" element={<PartnerAuth />} />
            <Route path="/partners" element={<PartnerDashboard />} />
            <Route path="/quote/:token" element={<PublicQuote />} />
            <Route path="/invoice/:token" element={<InvoicePublic />} />
            <Route path="/property-intelligence" element={<PropertyIntelligence />} />

            {/* Client account portal */}
            <Route path="/account/login" element={<AccountAuth />} />
            <Route path="/account/signup" element={<AccountAuth />} />
            <Route path="/account/auth/callback" element={<AccountAuthCallback />} />
            <Route path="/account/reset" element={<AccountReset />} />
            <Route path="/account" element={<AccountLayout />}>
              <Route index element={<AccountDashboard />} />
              <Route path="properties" element={<AccountProperties />} />
              <Route path="properties/:id" element={<PropertyPassport />} />
              <Route path="quotes" element={<AccountQuotes />} />
              <Route path="invoices" element={<AccountInvoices />} />
              <Route path="bookings" element={<AccountBookings />} />
              <Route path="notifications" element={<AccountNotifications />} />
              <Route path="profile" element={<AccountProfile />} />
              <Route path="rewards" element={<AccountRewards />} />
            </Route>
          </Routes>
        </BrowserRouter>
        </ErrorBoundary>
        <Toaster position="top-center" theme="dark" richColors />
      </SiteProvider>
    </div>
  );
}

export default App;
